import { Navigate } from 'react-router-dom';

const DashboardPage = () => Navigate({ to: '/pages' });

export { DashboardPage };
